angular.module('qkr').controller('TimezoneController', ['$uibModalInstance', 'utils', 'timezones', 'gettextCatalog',
    function($uibModalInstance, utils, timezones, gettextCatalog) {
	const self = this;
	self.errors = {};
	self.timezones = timezones;
	self.timezoneId = null;

	self.ok = function() {
		if (validate()) {
			$uibModalInstance.close(self.timezoneId);
		}
	};
	
	self.cancel = function() {
		$uibModalInstance.dismiss('cancel');
	};
	
	var validate = function() {
		self.errors = {};
		if (utils.hasNoValue(self.timezoneId)) {
			self.errors.timezone = gettextCatalog.getString('Please select a timezone');
			return false;
		}
		
		return true;
	};
}]);



// WEBPACK FOOTER //
// ./src/controllers/modal/timezone.controller.js